// extracted by mini-css-extract-plugin
module.exports = {"lockIcon":"Badge_lockIcon__1GQlu","label":"Badge_label__3bgFR","chip":"Badge_chip__1LK5g"};